import logo from './assets/logo.png';
import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, IconButton, Box, Button, Fab } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { Brightness4, Brightness7, ArrowBack, ArrowForward } from '@mui/icons-material';
import GoogleIcon from '@mui/icons-material/Google';
import { ThemeContext } from './theme/ThemeContext';
import { useAuth } from './context/AuthContext';
import LandingPage from './pages/LandingPage';
import AutomationsPage from './pages/AutomationsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ProfilePage from './pages/ProfilePage';
import WorkflowsPage from './pages/WorkflowsPage';
import WorkflowRunsPage from './pages/WorkflowRunsPage';
import PaymentsPage from './pages/PaymentsPage';
import SubscriptionPage from './pages/SubscriptionPage';
import Analytics from './components/Analytics';
import './App.css';

function App() {
  const { mode, toggleTheme } = useContext(ThemeContext);
  const { isAuthenticated, logout } = useAuth();

  const queryParams = new URLSearchParams(window.location.search);
  const enableGoogleSignIn = queryParams.has('enable_google_signin');

  const handleGoogleSignIn = () => {
    const clientId = process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_GOOGLE_OAUTH_REDIRECT_URI;
    const scopes = [
      "openid",
      "email",
      "profile",
      "https://www.googleapis.com/auth/drive.file"
    ].join(" ");

    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?` +
      `client_id=${encodeURIComponent(clientId)}` +
      `&redirect_uri=${encodeURIComponent(redirectUri)}` +
      `&response_type=code` +
      `&scope=${encodeURIComponent(scopes)}` +
      `&access_type=offline` +
      `&prompt=consent`;

    window.location.href = authUrl;
  };

  return (
    <SnackbarProvider maxSnack={3}>
      <Router>
        <Analytics />
        <AppBar position="static">
          <Toolbar>
            <Typography
              variant="h6"
              component={Link}
              to="/"
              sx={{ flexGrow: 1, textDecoration: 'none', color: 'inherit' }}
            >
              <img src={logo} alt="gdscreate-automations" />
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>

              {isAuthenticated ? (
                <>
                  <Button component={Link} to="/profile" color="inherit">
                    Profile
                  </Button>
                  <Button color="inherit" onClick={logout}>
                    Logout
                  </Button>
                </>
              ) : enableGoogleSignIn && (
                <Button
                  variant="contained"
                  startIcon={<GoogleIcon />}
                  onClick={handleGoogleSignIn}
                  sx={{
                    backgroundColor: '#4285F4',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: '#357ae8',
                    },
                  }}
                >
                Sign in
                </Button>
              )}
              <IconButton sx={{ ml: 1 }} onClick={toggleTheme} color="inherit">
                {mode === 'dark' ? <Brightness7 /> : <Brightness4 />}
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/automations" element={<AutomationsPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/workflows" element={<WorkflowsPage />} />
          <Route path="/workflow-runs/:workflowName" element={<WorkflowRunsPage />} />
          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/subscription/:workflowId" element={<SubscriptionPage />} />
        </Routes>
        <Box
          sx={{
            position: 'fixed',
            bottom: 16,
            right: 16,
            zIndex: 1000,
            display: 'flex',
            gap: 1,
          }}
        >
          <Fab
            color="primary"
            aria-label="back"
            onClick={() => window.history.back()}
            sx={{
              width: 40,
              height: 40,
              borderRadius: '8px',
            }}
          >
            <ArrowBack />
          </Fab>
          <Fab
            color="primary"
            aria-label="forward"
            onClick={() => window.history.forward()}
            sx={{
              width: 40,
              height: 40,
              borderRadius: '8px',
            }}
          >
            <ArrowForward />
          </Fab>
        </Box>
      </Router>
    </SnackbarProvider>
  );
}

export default App;